const initialState = {
  status: "invalid",
  data: null,
};

function PropertyReducer(state = initialState, action) {
  switch (action.type) {
    case "PROPERTY_RESET":
      return {
        status: "invalid",
      };
    case "PROPERTY_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "PROPERTY_SUCCESS":
      return {
        ...state,
        status: "success",
        data: action.data,
      };
    case "PROPERTY_FAILURE":
      return {
        ...state,
        status: "failure",
        err: action.err,
      };
    default:
      return state;
  }
}

export default PropertyReducer;
